import { render, staticRenderFns } from "./RespiraPayNotActivated.vue?vue&type=template&id=42846ee2&scoped=true&"
import script from "./RespiraPayNotActivated.vue?vue&type=script&lang=js&"
export * from "./RespiraPayNotActivated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42846ee2",
  null
  
)

export default component.exports